<ion-header>
    <ion-toolbar>
        <ion-title>email-login</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content> </ion-content>
